import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Layout from "../components/layout";
import { useAuth } from "../contexts/auth.context";

export const RequireAuth = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return <Layout>
    <Outlet />
  </Layout>;
};
